import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesPublisher: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-publisher`),
};

export default pagesPublisher;
